import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useMemo } from 'react'

interface MintCall {
  value: string | undefined
  calldata: string
}

/**
 * Returns the swap calls that can be used to make the trade
 * @param trade trade to execute
 * @param allowedSlippage user allowed slippage
 * @param recipientAddressOrName the ENS name or address of the recipient of the swap output
 * @param signatureData the signature data of the permit of the input token amount, if available
 */
export function useMintCallArguments(amount: number | undefined): MintCall {
  const { account, chainId, library } = useActiveWeb3React()

  return useMemo(() => {
    if (!amount || !library || !account || !chainId) return { value: undefined, calldata: '' }
    return { value: 'stuff', calldata: 'sup' }
  }, [account, amount, chainId, library])
}
